import { CToast } from "../../views/addons/ToastMessage";


export const copyInClipboard = (value, label = 'Texto') => {
    // Copy the text inside the text field
    navigator.clipboard.writeText(value);

    // Alert the copied text
    CToast({ title: 'Texto Copiado', message: `${label}: ${value}` }, 'success', { autoClose: 1300 })
}